export default __webpack_public_path__ + "static/media/fc_icon_bad_active.6b52acb9.svg";